import React, { useState, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import "./Cards.css";
import { Link } from "react-router-dom";
import Card from "./Card";
import Pagination from "./Pagination";
import SortingPanel from "./SortingPanel";
import settings, { saveSetting } from "./settings";
import CategoryTitle from "./CategoryTitle";
import { useLanguage } from "./LanguageContext";
import { eventsQueryKey, useEventsQuery } from "../queries/events";

function Events(props) {
  const { t } = useLanguage();
  const [resultsOnPage, setResultsOnPage] = useState(settings.resultsOnPageEvents);
  const [cardsSize, setCardsSize] = useState(settings.cardsSizeEvents);
  const [isSorted, setIsSorted] = useState(false);
  const queryClient = useQueryClient();

  const eventsQuery = useEventsQuery();
  const events = eventsQuery.data ?? [];
  const setEvents = (next) => queryClient.setQueryData(eventsQueryKey, next);
  const dataLoading = eventsQuery.isLoading;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  function setResultsOnPageWithSave(value) {
    setResultsOnPage(value);
    saveSetting("resultsOnPageEvents", value);
  }

  function handleCardsSizeClick() {
    const nextSize = !cardsSize;
    setCardsSize(nextSize);
    saveSetting("cardsSizeEvents", nextSize);
  }

  const hasEvents = events?.length > 0;
  const pagedEvents = hasEvents
    ? events.slice(props.pageNumber * resultsOnPage, props.pageNumber * resultsOnPage + resultsOnPage)
    : [];
  const eventCards = pagedEvents.map((event) => (
    <Card key={event._id} cardsCategory="events" event={event} cardsSize={cardsSize} />
  ));

  return (
    <div>
      <CategoryTitle category={props.category} />

      {hasEvents && dataLoading === false ? (
        <div>
          <SortingPanel
            breadcrumbCategory={props.category}
            resultsOnPage={resultsOnPage}
            setResultsOnPage={setResultsOnPageWithSave}
            cardsSize={handleCardsSizeClick}
            collection={events}
            setCollection={setEvents}
            setLoading={props.setLoading}
            target="event"
            setPageNumber={props.setPageNumber}
            isSorted={isSorted}
            setIsSorted={setIsSorted}
          />
          <Pagination
            resultsOnPage={resultsOnPage}
            pageNumber={props.pageNumber}
            setPageNumber={props.setPageNumber}
            collection={events}
          />
        </div>
      ) : null}

      {(events !== undefined && events.length <= 0 && dataLoading) || isSorted === false ? (
        <div className="loader"></div>
      ) : cardsSize ? (
        eventCards
      ) : (
        <div className="card-deck card-deck-cards">{eventCards}</div>
      )}

      <Pagination
        resultsOnPage={resultsOnPage}
        pageNumber={props.pageNumber}
        setPageNumber={props.setPageNumber}
        collection={events}
      />

      {!hasEvents && dataLoading === false ? (
        <div className="cards-bottom-text">
          <p>{t("empty")}</p>
          <p>{t("changeIt")}</p>
        </div>
      ) : null}

      <div className="cards-bottom-text">
        <Link to="/kontakt">{t("suggestEvent")}</Link>
      </div>
    </div>
  );
}

export default Events;
